;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"

/**
 * Replaces MUI <Badge color="secondary"> in the nav bar: renders the child
 * with an absolutely positioned count pill (bg #E6FF63 = theme secondary
 * main, text rgba(0,0,0,0.87) = computed contrast text).
 *
 * `offsetClassName` reproduces the old per-call-site StyledBadge transform
 * overrides (the pill's top-right corner starts at the child's top-right).
 */
export default function CountBadge({
  count,
  offsetClassName = "",
  children,
}: {
  count?: number
  offsetClassName?: string
  children: React.ReactNode
}) {
  if (!count) {
    return <>{children}</>
  }
  return (
    <span className="relative inline-flex shrink-0 align-middle">
      {children}
      <span
        className={`absolute top-0 right-0 z-[1] inline-flex h-5 min-w-5 items-center justify-center rounded-[10px] bg-[#E6FF63] px-[6px] font-roboto text-xs font-medium leading-none text-[rgba(0,0,0,0.87)] ${offsetClassName}`}
      >
        {count}
      </span>
    </span>
  )
}
